import React from 'react'
import block from 'bem-cn'

import useHideOverflow from 'shared/hooks/useHideOverFlow'

import './SideMenu.scss'

export type SideMenuPosition = 'left' | 'right'

export type SideMenuToggle = (val?: boolean) => void

interface ISideMenuProps {
  isOpen: boolean
  onToggleSideMenu: SideMenuToggle
  position?: SideMenuPosition
  children?: React.ReactNode
}

const b = block('side-menu')

export const SideMenu: React.FC<ISideMenuProps> = ({ isOpen, onToggleSideMenu, position = 'right', children }) => {
  useHideOverflow(isOpen)

  return (
    <aside className={b({ open: isOpen, position })}>
      <div className={b('plug', { closed: !isOpen })} onClick={() => onToggleSideMenu(false)} aria-hidden />

      <div className={b('content')}>{children}</div>
    </aside>
  )
}
